import type { AxiosResponse } from 'axios';
import { HttpStatusCode } from 'axios';

import type { AuthorizationResponse } from '@/types/auth.type';

export const SKIP_AUTH_REDIRECT = process.env.NEXT_PUBLIC_SKIP_AUTH_REDIRECT === '1';

/**
 * Value passed to `catch` after `dispatch(thunk()).unwrap()` rejects, or a defensive `{ payload }` shape.
 */
export function getAuthorizationPayloadFromCatch(
  reason: unknown,
): AxiosResponse<AuthorizationResponse> | undefined {
  if (reason !== null && typeof reason === 'object' && 'status' in reason) {
    return reason as AxiosResponse<AuthorizationResponse>;
  }
  return (reason as { payload?: AxiosResponse<AuthorizationResponse> })?.payload;
}

export const isValidToken = (value: unknown): value is string =>
  typeof value === 'string' && value.length > 0 && value !== 'undefined';

export const isUnauthorized = (status?: number) => status === HttpStatusCode.Unauthorized;
export const isClientOrServerError = (status?: number) => (status ?? 0) >= 400;
export const isSuccess = (status?: number) => (status ?? 0) >= 200 && (status ?? 0) < 400;
